module.exports = __webpack_public_path__ + "static/media/bookActive.13a7103c.svg";